import { render, staticRenderFns } from "./TranscriptInfo.vue?vue&type=template&id=1a2e15fb"
import script from "./TranscriptInfo.vue?vue&type=script&lang=js"
export * from "./TranscriptInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports